
<template>
  <div>
    <div class="list-widget__content items-container">
      <template v-for="item in accounts">
        <router-link class="items-container__item item" :to="{ name: 'account', params: {id: item.id}}" >
          <div class="item__row item__title">
            <slot name="item-template-title" :item="item">
              <span>{{ item.name }}</span>
            </slot>
          </div>
          <div class="item__statusbar">
            <span class="filling" style="width: 100%"></span>
          </div>
          <div class="item__row item__subtitle">
            <slot name="item-template-subtitle" :item="item">
              <span>{{ item.email }}</span>
            </slot>
          </div>
        </router-link>
      </template>
    </div>
    <div class="list-widget__footer items-container__footer" v-if="accounts">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListWidget from 'common/ListWidget';

export default {
  components: {
    ListWidget,
  },
  computed: mapGetters({
    user: 'user/user/user',
    accounts: 'accounts/accounts/accounts',
  }),
  created() {
    this.fetchAccounts();
  },
  methods: {
    fetchAccounts() {
      const id = this.user.data.selectedRole.id;
      if (id) {
        this.$store.dispatch('accounts/accounts/fetch', { id, user: this.user }).then(() => {
        });
      }
    },
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/accounts/Sidebar.vue